<ng-container *ngIf="!isQscV2; else qscDropdown">
<div class="quantity-stepper-v3">
    <div class="quantity-stepper-container">
        <div class="product-btn" [ngClass]="{'product-btn--with-addl-info': isAnyProductHasAddlInfo,'product-btn--without-ar': !isAnyProductHasAddlInfo}">
            <div data-qa="addbutton" role="button" tabindex="0"
                class="btn product-btn__add product-btn--signin" id="signIn-weight_{{product.id}}"
                attr.data-qty-id="pc{{product.id}}Inpt"
                attr.aria-label="Sign In to Add weight {{product.name}}"
                (click)="displayWeights($event)" *ngIf="!isAuthorized">
                {{ isAuthorized ? selectedWeightText : SIGNIN }}
            </div>
            <div class="dropdown est__dropdown" [ngClass]="{'dropup' : calledBy === 'carousel'}" *ngIf="isAuthorized && !isButtonenabled"  id="select-weight_{{product.id}}">
                <ng-container *ngIf="(screenSize >= 1024 || noWeightModal) else selectWeightButton">
                    <button class="est__dropdown--button btn btn_qty-stepper" id="qtyDropdownBtn_{{product.id}}"
                     aria-haspopup="true" attr.aria-controls="qtyDropdownContentList_{{product.id}}"
                     (click)="displayWeights($event)" attr.aria-expanded="{{showWeights}}"
                    attr.aria-label="select weight {{product.name}}">
                    {{ selectedWeightText }}
                    </button>
                </ng-container>
                <ng-template #selectWeightButton>
                    <button class="btn product-btn__add product-btn--signin" id="qtyModalBtn_{{product.id}}"
                      (click)="displayWeights($event)" attr.aria-expanded="{{showModal}}"
                      attr.aria-label="select weight {{product.name}}">
                    {{ selectedWeightText }}
                    </button>
                </ng-template>
                <div class="dropdown-menu  est__dropdown--menu" [ngClass]="{'est__dropdown--menu--display' : showWeights}" *ngIf="showWeights">
                    <ul class="est__dropdown--menu--item--container" (focusout)="dropdownFocusout($event)"
                    tabindex="-1" id="qtyDropdownContentList_{{product.id}}" role="menu" attr.aria-labelledby="qtyDropdownBtn_{{product.id}}">
                        <li *ngFor="let item of weightList; let i=index"
                        class="dropdown-item est__dropdown--menu--item"
                        id="dropdown-itm{{i}}"
                        (click)="selectWeight(i)"
                        (mouseenter)="mouseEnter(i)"
                        (keypress)="selectWeight(i)"
                        role="menuitem"
                        tabindex="0">
                        {{ item.weight | number:'1.2' }} lb
                        </li>
                        <li class="dropdown-item est__dropdown--menu--item-remove" [ngClass]="{'est__dropdown--menu--item-remove--disabled' : selectedWeight === 0}"
                        (click)="removeSelection()"
                        (keypress)="removeSelection()"
                        (mouseenter)="mouseEnterRemoveBtn()"
                        role="menuitem"
                        tabindex="0">
                          Remove
                        </li>
                    </ul>
                    <div>
                      <span aria-live="polite">
                        <span class="dropdown-item est__dropdown--selected--price" aria-hidden="true"><span class="quantity-dropdown__est-total--label">Est. Total: &nbsp; </span>{{ estimatedPrice | currency: 'USD' }}</span>
                        <span class="sr-only">Estimated Total:</span>
                        <span class="sr-only">{{ estimatedPrice | currency: 'USD' }}</span>
                      </span>
                      <div class="dropdown-item est__dropdown--selected--price--helper">Final cost by weight</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-container *ngIf="isButtonenabled">
    <div class="quantity-stepper-v3">
        <div class="quantity-stepper-container">
            <div class="product-btn" [ngClass]="{'product-btn--without-ar': configObj?.programType !== 'mkp'}">
                <div [ngClass]="{'btn':true, 'product-btn__qty-step': true, 'product-btn__qty-step--loading':loadingSpinner}"
                  role="group" aria-describedby="123pg960161868">
                    <button aria-label="Decrement quantity" class="product-btn__qty-step__decrease"
                        id="dec_qtyInfo_{{product.id}}" (click)=decreaseWeight() data-qa="prdctdcrmntr" role="button" tabindex="0" id="dec_qtyInfo_{{product.id}}">
                        <span aria-hidden="true"
                            class="svg-qty-stepper-decrease product-btn__qty-step__decrease--icon"></span>
                    </button>
                    <span class="sr-only"></span>
                    <span class="product-btn__qty-step__amt product-btn__qty-step__amt__amt-text"
                        data-qa="prd-qty-stppr-qtymsg" role="button" tabindex="0" id="qtyInfo_{{product.id}}"
                        attr.aria-label="{{selectedWeight}} lb of {{product.name}} in cart" (click) = "!noWeightModal && displayModal($event)">
                        {{ selectedWeightText }} </span>
                    <button aria-label="Increment quantity" class="product-btn__qty-step__increase"
                        data-qa="prdctincrmntr" role="button" tabindex="0" id="inc_qtyInfo_{{product.id}}"
                        id="inc_qtyInfo_{{product.id}}" (click)="increaseWeight()" [disabled]="checkIncreaseButtonDisability()">
                        <span aria-hidden="true"
                            class="svg-qty-stepper-increase product-btn__qty-step__increase--icon"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="showModal">
    <div class="quantity-stepper-v3">
      <div class="quantity-stepper-container">
        <div class="modal qty-modal fade" id="modal-est" attr.aria-label="Select weight for {{product.name}}" role="dialog" tabindex="-1">
          <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button class="close"
              (click)="closeModal()"
              (keypress)="closeModal()"
              aria-label="Close">
              <span class="svg-icon svg-close" aria-hidden="true"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="product">
              <div class="product__image-container" aria-hidden="true">
                  <picture>
                    <source media="(max-width: 575px)" [attr.srcset]="getImageUrl(product.id,'mobile')">
                    <source media="(max-width: 768px)" [attr.srcset]="getImageUrl(product.id,'tablet')">
                    <img class="ab-lazy" [attr.src]="getImageUrl(product.id,'desktop')" alt="{{ product.name }}" data-qa="prd-itm-img" />
                  </picture>
              </div>
              <div class="product__title">
                <p class="title-md mb-4">{{product.name}}</p>
              </div>
            </div>
            <hr class="gray-darker" aria-hidden="true">
            <div class="amount">
              <p class="amount__label body-text-sm">Final cost by weight</p>
              <div class="row amount__info">
                <div class="amount__info__per-unit title-sm-bold">{{ product.pricePer | currency: 'USD' }} / {{ product.unitQuantity | lowercase}}</div>
                <div tabindex="0" class="amount__info__est">
                  <!-- Announce Estimated Total -->
                  <span class="sr-only amount__info__est" aria-live="polite">
                    Estimated Total {{ estimatedPrice | currency: 'USD' }}
                  </span>
                  <div aria-hidden="true" class="amount__info__est--label body-text-sm">Est. total
                  </div>
                  <div aria-hidden="true" class="amount__info__est--price title-sm-bold">{{ estimatedPrice | currency: 'USD' }}</div>
                </div>
              </div>
              <div>
                <select class="amount__select" (change)="SelectWeightModal($event)">
                    <option *ngFor="let item of weightList; let i=index" class="options" [value]="item.weight" [selected]="item.weight === selectedItem()" [attr.aria-label]="getAriaLabel(item.weight)">{{ item.weight | number:'1.2' }} &nbsp; lb</option>
                </select>
              </div>
              <div class="amount__add-qty-btn">
                <button class="btn btn-primary"
                (click)="finalizeWeight()"
                (keypress)="finalizeWeight()">Add
              </button>
              </div>
            </div>
          </div>
        </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #qscDropdown>
  <div class="quantity-stepper-v3 qsc-dropdown-v2-default" [ngClass]="{'qsc-dropdown-v2-extended' : isExtended}">
    <div class="quantity-stepper-container">
      <div class="dropdown est__dropdown" id="select-weight_{{product.id}}">
        <button class="est__dropdown--button btn btn_qty-stepper-lb qsc-btn_qty-stepper-lb" [ngClass]="{'qsc-btn_qty-stepper-lb__disabled' : !isCheckboxChecked, 'qsc-btn_qty-stepper-lb__after' : isExtended}" id="qtyDropdownBtn_{{product.id}}"
          (click)="qscDisplayWeights($event)" aria-haspopup="true" attr.aria-controls="qtyDropdownContentList_{{product.id}}"
          attr.aria-expanded="{{showWeights}}" attr.aria-label="select weight {{product.name}}" [disabled]="!isCheckboxChecked">
          {{ selectedWeightText }}
        </button>
        <div class="dropdown-menu est__dropdown--menu qsc-dropdown-menu" [ngClass]="{'est__dropdown--menu--display' : showWeights}" *ngIf="showWeights">
          <ul class="est__dropdown--menu--item--container qsc-dropdown-menu-item-container" tabindex="-1"
            id="qtyDropdownContentList_{{product.id}}" role="menu" attr.aria-labelledby="qtyDropdownBtn_{{product.id}}"
            tabindex="-1" (focusout)="dropdownFocusout($event)">
            <li *ngFor="let item of weightList; let i = index" class="dropdown-item est__dropdown--menu--item qsc-dropdown-item"
              id="dropdown-itm{{i}}" role="menuitem" (mouseenter)="mouseEnter(i)" (click)="selectWeight(i)" (keypress)="selectWeight(i)" tabindex="0">
              {{ item.weight | number:'1.2' }} lb
            </li>
            <li class="dropdown-item est__dropdown--menu--item-remove qsc-dropdown-item"
              [ngClass]="{'est__dropdown--menu--item-remove--disabled' : selectedWeight === 0}" (click)="qscV2RemoveSelection()"
              (keypress)="qscV2RemoveSelection()" (mouseenter)="mouseEnterRemoveBtn()" role="menuitem" tabindex="0">
              Remove
            </li>
          </ul>
          <div>
            <span aria-live="polite" class="qsc-dropdown-selected-container">
              <span class="dropdown-item est__dropdown--selected--price qsc-dropdown-selected-price" aria-hidden="true">
                <span class="quantity-dropdown__est-total--label qsc-dropdown-total-label">Est. Total: &nbsp; </span>
                {{ estimatedPrice | currency: 'USD' }}
              </span>
              <span class="sr-only">Estimated Total:</span>
              <span class="sr-only">{{ estimatedPrice | currency: 'USD' }}</span>
              <div class="dropdown-item est__dropdown--selected--price--helper qsc-dropdown-selected-price-helper">Final cost by weight</div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="showModal">
    <div class="quantity-stepper-v3">
      <div class="quantity-stepper-container">
        <div class="modal qty-modal fade" id="modal-est" attr.aria-label="Select weight for {{product.name}}" role="dialog" tabindex="-1">
          <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button class="close"
              (click)="closeModal()"
              (keypress)="closeModal()"
              aria-label="Close">
              <span class="svg-icon svg-close" aria-hidden="true"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="product">
              <div class="product__image-container" aria-hidden="true">
                  <picture>
                    <source media="(max-width: 575px)" [attr.srcset]="getImageUrl(product.id,'mobile')">
                    <source media="(max-width: 768px)" [attr.srcset]="getImageUrl(product.id,'tablet')">
                    <img class="ab-lazy" [attr.src]="getImageUrl(product.id,'desktop')" alt="{{ product.name }}" data-qa="prd-itm-img" />
                  </picture>
              </div>
              <div class="product__title">
                <p class="title-md mb-4">{{product.name}}</p>
              </div>
            </div>
            <hr class="gray-darker" aria-hidden="true">
            <div class="amount">
              <p class="amount__label body-text-sm">Final cost by weight</p>
              <div class="row amount__info">
                <div class="amount__info__per-unit title-sm-bold">{{ product.pricePer | currency: 'USD' }} / {{ product.unitQuantity | lowercase}}</div>
                <div tabindex="0" class="amount__info__est">
                  <!-- Announce Estimated Total -->
                  <span class="sr-only amount__info__est" aria-live="polite">
                    Estimated Total {{ estimatedPrice | currency: 'USD' }}
                  </span>
                  <div aria-hidden="true" class="amount__info__est--label body-text-sm">Est. total
                  </div>
                  <div aria-hidden="true" class="amount__info__est--price title-sm-bold">{{ estimatedPrice | currency: 'USD' }}</div>
                </div>
              </div>
              <div>
                <select class="amount__select" (change)="SelectWeightModal($event)">
                    <option *ngFor="let item of weightList; let i=index" class="options" [value]="item.weight" [selected]="item.weight === selectedItem()" [attr.aria-label]="getAriaLabel(item.weight)">{{ item.weight | number:'1.2' }} &nbsp; lb</option>
                </select>
              </div>
              <div class="amount__add-qty-btn">
                <button class="btn btn-primary"
                (click)="finalizeWeight()"
                (keypress)="finalizeWeight()">Add
              </button>
              </div>
            </div>
          </div>
        </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>